import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constant/routeConstant";
import { deleteDeliveryType, editDeliveryType, getDetailDeliveryType, getListDeliveryType, getListDeliveryTypeDropdown, getManagementHistoryList, getSearchRecommendation, getSearchResult, initiateDeliveryType, postDeliveryType } from "../../../../service/master/DeliveryType/DeliveryTypeService";
import moment from "moment";
import _ from "lodash";
import { validDT } from "./validation";
import { useTranslation } from "react-i18next";

export const useDeliveryType = () => {
    const { token } = useSelector((state) => state.auth);
    const [list, setList] = useState()
    const [detailDeliveryType, setDetailDeliveryType] = useState()

    const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false)
    const [successModalOpen, setSuccessModalOpen] = useState(false)
    const [userManagementOpen, setUserManagementOpen] = useState(false)

    const [deliveryType, setDeliveryType] = useState()
    const [deliveryTypeDescription, setDeliveryTypeDescription] = useState()

    const [deliveryTypeError, setDeliveryTypeError] = useState(false)
    const [deliveryTypeDescriptionError, setDeliveryTypeDescriptionError] = useState(false)

    const [selectedDepotId, setSelectedDepotId] = useState(1)
    const [totalData, setTotalData] = useState()
    const [pageLimit, setPageLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [listDropdown, setListDropdown] = useState([])

    const [isEdited, setIsEdited] = useState(false)

    const [showConfirm, setShowConfirm] = useState(false)

    const [selectedDeliveryType, setSelectedDeliveryType] = useState()
    const [selectedDeliveryTypeId, setSelectedDeliveryTypeId] = useState()
    const [selectedUpdatedAt, setSelectedUpdatedAt] = useState()

    const [statePageSize, setStatePageSize] = useState(10)

    const [options, setOptions] = useState()
    const [searchKeyword, setSearchKeyword] = useState()

    const [sorting, setSorting] = useState("delivery_type asc")

    const [managementHistoryList, setManagementHistoryList] = useState([])

    const [failedModalOpen, setFailedModalOpen] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [dropdownListLoading, setDropdownListLoading] = useState(false)
    const [depotKeyword, setDepotKeyword] = useState('')
    const [depotListPage, setDepotListPage] = useState(1)
    const [operationalDate, setOperationalDate] = useState([
        {
          operational_day: "Sunday",
          operational_start_time: "00:00",
          operational_end_time: "00:00",
          is_operational_active: "Y",
        },
      ])
    const [isSupportMitraGro, setIsSupportMitraGro] = useState(false)
    const {t} = useTranslation()
    
  const [form, setForm] = useState([]);
  const [error, setError] = useState();

    useEffect(() => {
        doGetListDropdown(depotListPage)

        if (selectedDepotId !== undefined) {
            doInitializeDeliveryType(selectedDepotId)
            doGetDeliveryType(selectedDepotId, 1, 10, sorting)
        }
    }, [])

    const handleChangeLimit = (page, value, selectedDepotId) => {
        setStatePageSize(value)
        setCurrentPage(page)
        handlePagination(page, value, selectedDepotId)
    }

    const onScroll = (event, namespace) => {
        let target = event.target
        switch (namespace) {
            case 'depotList':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    doGetListDropdown(depotListPage + 1, depotKeyword)
                    setDepotListPage(depotListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;

            default:
                break;
        }
    }

    const onSearchDDS = (keyword, namespace) => {
        switch (namespace) {
            case 'depotList':
                setDepotKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    doGetListDropdown(1, keyword, 'searchList')
                }
                setDepotListPage(1)
                break;

            default:
                break;
        }
    }

    const doInitializeDeliveryType = async (selectedDepotId, filter) => {
        try {
            // if (selectedDepotId !== undefined) {
                const response = await initiateDeliveryType(token, null, selectedDepotId,filter, dispatch);
                if (response && response.ok) {
                    setTotalData(response.data.count_data)
                }
            // }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetManagementHistoryList = async (id) => {
        try {
            const response = await getManagementHistoryList(token, null, dispatch, id);
            if (response && response.ok) {
                const data = response.data
                const reorderedData = []

                for (let i = data.length - 1; i >= 0; i--) {
                    const element = data[i];
                    reorderedData.push(element)
                }

                setManagementHistoryList(reorderedData)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetDeliveryType = async (selectedDepotId, page, pageLimit, sort, isClear) => {
if(isClear){
    
    setSearchKeyword()
}

doInitializeDeliveryType()
        const param = `page=${page}&limit=${pageLimit}&order=${typeof sort !== 'undefined' ? sort : sorting}`

        try {
            const response = await getListDeliveryType(token, null, param, "", dispatch)
            if (response && response.ok) {
                setList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetListDropdown = async (page, keyword = '', flag = 'list') => {
        setDropdownListLoading(true)
        try {
            const response = await getListDeliveryTypeDropdown(token, page, keyword, null, dispatch);
            if (response && response.ok) {
                setSelectedDepotId(response.data[0].id)
                if (flag === 'list') {
                    if (listDropdown.length === 0) {
                        console.log(response.data)
                        setListDropdown(response.data)
                    } else {
                        let tempListDropdown = [...listDropdown]
                        response.data.map(item => tempListDropdown.push(item))
                        setListDropdown(tempListDropdown)
                    }
                    setDropdownListLoading(false)
                } else if (flag === 'searchList') {
                    setListDropdown(response.data)
                }
            }

        } catch (error) {
            console.log(error)
        }
    }

    const doGetDetailDeliveryType = async (id) => {
        try {
            const response = await getDetailDeliveryType(token, null, id, dispatch);
            if (response && response.ok) {
                setDetailDeliveryType(response.data)
                setForm(response.data)
                setOperationalDate([{
                    operational_start_time: response.data?.start_trip_time ? response.data?.start_trip_time : "00:00",
                    is_operational_active: response.data?.automatic_start_trip ? "Y" : "N",
                  }])
                setIsSupportMitraGro(response?.data?.support_mitra_gro)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const validateSubmit = (error) => {
        for (const key in error) {
          if (Object.hasOwnProperty.call(error, key)) {
            if (error[key]) return false;
          }
        }
        return true;
      };
    const doPostDeliveryType = async (depot_id) => {
        let errors={}
        let dataCheck ={
            "price_weight":form?.price_weight ?parseFloat(form?.price_weight) : "",
            "price_volume":form?.price_volume ?parseFloat(form?.price_volume) : "",
            "price_distance":form?.price_distance ?parseFloat(form?.price_distance) : "",
            "price_time":form?.price_time ?parseFloat(form?.price_time) : "",
            "base_price":form?.base_price ?parseFloat(form?.base_price) : "",
            "delivery_code": form?.delivery_code ? form?.delivery_code :"",
            "delivery_type": form?.delivery_type ? form?.delivery_type :"",
            "description": form?.description ? form?.description :""
        }
        for (const key in dataCheck) {
            const option = validDT(key, dataCheck[key], t);
            // let option = validUserProfile(key, value[key], this.props.t);
            const currentError = option;
            errors = { ...currentError, ...errors };
          }
          setError(errors);
          if (validateSubmit(errors)) {
        // if (checkForm()) {
            let data = {
                ...dataCheck,
                // // 'depot_id': depot_id,
                // "delivery_code": "SHP",
                // "delivery_type": deliveryType,
                // "description": deliveryTypeDescription,
                
    "automatic_start_trip":operationalDate[0]?.is_operational_active === "Y" ? true : false,
    "start_trip_time":operationalDate[0]?.operational_start_time,
    "support_mitra_gro": isSupportMitraGro
            }

            try {
                const response = await postDeliveryType(token, null, data, dispatch)
                if (response && response.ok) {
                    setSuccessModalOpen(true)
                } else if (response.code === 400 && response.message === 'E-4-GL-SRV-004') {
                    setFailedModalOpen(true)
                }
            } catch (error) {
                console.log(error)
            }
        // }
    }
    }

    const doEditDeliveryType = async (data) => {
        let errors={}
        let dataCheck ={
            "price_weight":form?.price_weight ?parseFloat(form?.price_weight) : "",
            "price_volume":form?.price_volume ?parseFloat(form?.price_volume) : "",
            "price_distance":form?.price_distance ?parseFloat(form?.price_distance) : "",
            "price_time":form?.price_time ?parseFloat(form?.price_time) : "",
            "base_price":form?.base_price ?parseFloat(form?.base_price) : "",
            "delivery_code": form?.delivery_code ? form?.delivery_code :"",
            "delivery_type": form?.delivery_type ? form?.delivery_type :"",
            "description": form?.description ? form?.description :"",

        }
        for (const key in dataCheck) {
            const option = validDT(key, dataCheck[key], t);
            // let option = validUserProfile(key, value[key], this.props.t);
            const currentError = option;
            errors = { ...currentError, ...errors };
          }
          setError(errors);
          if (validateSubmit(errors)) {
        // if (checkForm()) {
            const updatedData = {
                // 'depot_id': data.depot_id,
                ...dataCheck,
                // "delivery_type": deliveryType,
                // "description": deliveryTypeDescription,
    "automatic_start_trip":operationalDate[0]?.is_operational_active === "Y" ? true : false,
    "start_trip_time":operationalDate[0]?.operational_start_time,
                "updated_at": data.updated_at,
                "support_mitra_gro": isSupportMitraGro
            }
            try {
                const response = await editDeliveryType(token, null, data.delivery_type_id, updatedData, dispatch)
                if (response && response.ok) {
                    setSuccessModalOpen(true)
                } 
                else if (response.code === 400 && response.message === 'E-4-GL-SRV-004') {
                    setFailedModalOpen(true)
                }
                setFailedModalOpen(response.code === 400 ? true : false)
            } catch (error) {
                setFailedModalOpen(true)
                console.log(error)
            }
        }
        // }
    }
    const checkForm = () => {
        if (deliveryType !== '' && deliveryTypeDescription !== '' && typeof deliveryType !== 'undefined' && typeof deliveryTypeDescription !== 'undefined') {
            return true
        } else {
            if (deliveryType === '' || typeof deliveryType === 'undefined') {
                setDeliveryTypeError(true)
            } else {
                setDeliveryTypeError(false)
            }

            if (deliveryTypeDescription === '' || typeof deliveryTypeDescription === 'undefined') {
                setDeliveryTypeDescriptionError(true)
            } else {
                setDeliveryTypeDescriptionError(false)
            }
            return false
        }
    }

    const checkEdit = () => {
        const init = detailDeliveryType
        if ((init.delivery_type !== deliveryType) || (init.description !== deliveryTypeDescription)) {
            setIsEdited(true)
            setShowConfirm(true)
        } else {
            setIsEdited(false)
            setShowConfirm(false)
            toListDeliveryType()
        }
    }

    const isClear = () => {
        if (deliveryType || deliveryTypeDescription) {
            return false
        } else {
            return true
        }
    }

    const doSearch = async (keyword) => {
        try {
            const response = await getSearchRecommendation(token, null, selectedDepotId, keyword, dispatch);
            if (response && response.ok) {
                setOptions(response.data.map((el) => ({
                    value: el.id,
                    label: el.value
                })))
            }
        } catch (error) {
            console.log(error)
        }
    }

    const onSearch = (event) => {
        console.log("checking",event.target.value);
        setSearchKeyword(event.target.value)
        doSearch(event.target.value)
    }

    const onSelect = async (keyword) => {
        setSearchKeyword(options[_.findIndex(options,(el)=>el.value === keyword)]?.label)
        let key =options[_.findIndex(options,(el)=>el.value === keyword)]?.label
        console.log("key", options[_.findIndex(options,(el)=>el.value === keyword)]?.label);
        try {
            const response = await getSearchResult(token, null, key, dispatch);
            if (response && response.ok) {
                setList(response.data)
                
        doInitializeDeliveryType(selectedDepotId, key)
        setCurrentPage(1)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doDeleteDeliveryTypeFromDetail = () => {
        doDeleteDeliveryType()
        toListDeliveryType()
    }

    const onChange = (event, namespace) => {
        let eror = validDT(namespace, event.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: event.target.value,
        };
      });
        // switch (namespace) {
        //     case 'delivery_type':
        //         // if (event !== null) {
        //         //     setDeliveryTypeError(false)
        //         // } else {
        //         //     setDeliveryTypeError(true)
        //         // }
        //         setDeliveryType(event.target.value)
        //         // console.log('deliveryType', event.target.value)
        //         break;
        //     case 'description':
        //         // if (event !== null) {
        //         //     setDeliveryTypeDescriptionError(false)
        //         // } else {
        //         //     setDeliveryTypeDescriptionError(true)
        //         // }
        //         setDeliveryTypeDescription(event.target.value)
        //         // console.log('description', event.target.value)
        //         break;
        //     default:
        //         break;
        // }

    }

    const handlePagination = (page, pageSize) => {
        doInitializeDeliveryType(selectedDepotId)
        doGetDeliveryType(selectedDepotId, page, pageSize)
    }

    const selectDepotId = async (id, page, pageLimit) => {
        setSelectedDepotId(id)
        await doInitializeDeliveryType(id)
        await doGetDeliveryType(id, page, pageLimit)
    }

    const doDeleteDeliveryType = async () => {
        try {
            const response = await deleteDeliveryType(token, null, selectedDeliveryTypeId, selectedUpdatedAt, dispatch)
            if (response && response.ok) {
                setDeleteConfirmationModalOpen(false)
                setSuccessModalOpen(true)
                setSelectedDeliveryTypeId()
                setSelectedUpdatedAt()
                doGetDeliveryType("", 1, 10, sorting)
            }
        } catch (error) {
            console.log(error)
        }
    }

    function deleteConfirmation(delivery_type_id, updated_at, delivery_type) {
        setSelectedDeliveryType(delivery_type)
        setSelectedDeliveryTypeId(delivery_type_id)
        setSelectedUpdatedAt(updated_at)

        setDeleteConfirmationModalOpen(true)
    }

    const toAddDeliveryType = () => {
        navigate(ROUTES.DELIVERY_TYPE.ADD, {
            state: {
                depotId: selectedDepotId
            }
        })
    }

    const toListDeliveryType = () => {
        navigate(ROUTES.DELIVERY_TYPE.LIST)
    }

    const toEditDeliveryType = (data) => {
        navigate(ROUTES.DELIVERY_TYPE.EDIT, {
            state: {
                data
            }
        })
    }

    const toDetailDeliveryType = (id) => {
        navigate(ROUTES.DELIVERY_TYPE.DETAIL, {
            state: {
                id
            }
        })
    }

    const convertTimestamp = (timestamp, isSpecific) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthNumbers = ["01", "02", "03", "04", "05", "06",
            "07", "08", "09", "10", "11", "12"
        ];

        // Extract components from the timestamp string
        const year = timestamp?.substring(0, 4);
        const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
        const day = timestamp?.substring(8, 10);

        let dateFormat = new Date(year, month, day);

        if (isSpecific) {
            return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
        } else {
            return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
        }
    }

    const convertToTime = (timestamp) => {
        let time = new Date(timestamp);
        return (moment(timestamp).utc().format('HH:mm'))
    }

    const doSort = (sort) => {
        console.log(sort)
        setSorting(sort);
        doGetDeliveryType(selectedDepotId, page, pageLimit, sort);
    }

    const setEditedData = (data) => {
        setDeliveryType(data.delivery_type)
        setDeliveryTypeDescription(data.description)
    }

    const handleSupportMitraGro = (event)=>{
        console.log("event", event);
        setIsSupportMitraGro(event)
    }

    const handleToogle = (d, i) => {
        const newDetail = [...operationalDate];
        newDetail[i]["is_operational_active"] = d === "Y" ? "N" : "Y";
        if (d === "Y") {
          newDetail[i]["operational_start_time"] = "00:00"
          newDetail[i]["operational_end_time"] = "00:00"
        }
        setOperationalDate(newDetail)
      };
    
      const [errTime, setErrTime] = useState(["", "", "", "", "", "", ""])
      
      const handleChangeTime = (value, key, index, i) => {
        const newDetail = [...operationalDate];
        const newErr = [...errTime]
    const newFormat = index === 0 ? Number(value.target.value) > 23 ? 23 : Number(value.target.value) : Number(value.target.value) > 59 ? 59 : Number(value.target.value)
        // if(index===0){
        newDetail[i][key] = index === 0 ? newFormat + ":" + newDetail[i][key].split(":")[1] : newDetail[i][key].split(":")[0] + ":" + newFormat
    
        // }else{
        // newDetail[i][key]= newDetail[i][key].split(":")[0]+":"+value.target.value
        // }
        setOperationalDate(newDetail)
      }
    
      const handleBlur = (value, key, index, i)=>{
        const newDetail = [...operationalDate];
        const newErr = [...errTime];
        newDetail[i][key] = index === 0 ?(value.length===1 ? "0"+value : value) + ":" + newDetail[i][key].split(":")[1] : newDetail[i][key].split(":")[0] + ":" + (value.length===1 ? "0"+value : value) 
    setOperationalDate(newDetail);
      }
    
    
    return {
        deleteConfirmationModalOpen,
        setDeleteConfirmationModalOpen,
        successModalOpen,
        setSuccessModalOpen,
        toAddDeliveryType,
        toEditDeliveryType,
        toDetailDeliveryType,
        deleteConfirmation,
        doGetDeliveryType,
        list,
        detailDeliveryType,
        userManagementOpen,
        setUserManagementOpen,
        doGetDetailDeliveryType,
        convertTimestamp,
        convertToTime,
        listDropdown,
        totalData,
        handlePagination,
        selectDepotId,
        deliveryType,
        deliveryTypeDescription,
        deliveryTypeError,
        deliveryTypeDescriptionError,
        onChange,
        doPostDeliveryType,
        deliveryTypeDescriptionError,
        deliveryTypeError,
        toListDeliveryType,
        sorting,
        setSorting,
        doSort,
        selectedDeliveryType,
        selectedDeliveryTypeId,
        selectedUpdatedAt,
        doDeleteDeliveryType,
        doEditDeliveryType,
        checkEdit,
        isEdited,
        setShowConfirm,
        showConfirm,
        setEditedData,
        options,
        onSelect,
        onSearch,
        searchKeyword,
        statePageSize,
        setStatePageSize,
        handleChangeLimit,
        selectedDepotId,
        isClear,
        doDeleteDeliveryTypeFromDetail,
        doGetManagementHistoryList,
        managementHistoryList,
        failedModalOpen,
        setFailedModalOpen,
        currentPage,
        onScroll,
        onSearchDDS,
        depotKeyword,
        dropdownListLoading,
        form,
        error, 
        operationalDate,
        handleChangeTime,
        handleBlur,
        handleToogle,
        handleSupportMitraGro,
        isSupportMitraGro
    }
}